import { render, staticRenderFns } from "./CuponDetalle.vue?vue&type=template&id=dcc4e9e6"
import script from "./CuponDetalle.vue?vue&type=script&lang=js"
export * from "./CuponDetalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dcc4e9e6')) {
      api.createRecord('dcc4e9e6', component.options)
    } else {
      api.reload('dcc4e9e6', component.options)
    }
    module.hot.accept("./CuponDetalle.vue?vue&type=template&id=dcc4e9e6", function () {
      api.rerender('dcc4e9e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/settings/CuponDetalle.vue"
export default component.exports